var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1113 6.46787L14.6113 2.34287C14.5005 2.28195 14.3762 2.25 14.2498 2.25C14.1234 2.25 13.999 2.28195 13.8883 2.34287L6.38827 6.46787C6.27068 6.53261 6.17262 6.62773 6.10432 6.7433C6.03603 6.85886 6 6.99064 6 7.12487C6 7.25911 6.03603 7.39088 6.10432 7.50645C6.17262 7.62201 6.27068 7.71713 6.38827 7.78187L13.4998 11.6931V19.7324L11.2228 18.4799L10.4998 19.7931L13.8883 21.6569C13.999 21.7178 14.1234 21.7497 14.2498 21.7497C14.3762 21.7497 14.5005 21.7178 14.6113 21.6569L22.1113 17.5319C22.2289 17.4672 22.327 17.3721 22.3953 17.2565C22.4637 17.1409 22.4997 17.0091 22.4998 16.8749V7.12487C22.4997 6.99061 22.4637 6.85882 22.3953 6.74325C22.327 6.62769 22.2289 6.53258 22.1113 6.46787ZM14.2498 3.85637L20.1935 7.12487L14.2498 10.3934L8.30602 7.12487L14.2498 3.85637ZM20.9998 16.4316L14.9998 19.7316V11.6924L20.9998 8.39237V16.4316Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12H1.5V10.5H7.5V12ZM9 18H3V16.5H9V18ZM10.5 15H4.5V13.5H10.5V15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.28f94fbc7106f423d0590014195be973.svg";
export { ForwardRef as ReactComponent };